import {
    ILevelDataMap,
    IPlayerState,
    ILevelData,
} from '../../../State/Player/IPlayerState';
import { getNewLevelData } from '../../../State/Player/PlayerLevelHelper';
import IPlayerData from '../../IPlayerData';
import { restoreStringifiedArray } from '../../ParseHelper';
import PlayerProperty from '../PlayerProperty';

export default class Levels extends PlayerProperty<
    ILevelDataMap,
    {
        level_star: string;
    }
> {
    public readonly defaultValue: ILevelDataMap;

    public save(playerStateData: IPlayerState) {
        // Convert level data array back to 'level_star' array indexed by levelNumber.
        const levelData: number[] = [];

        // Get highest level number and pre-fill level_star array with zeroes (stars).
        // This way in case there are gaps between levels they are still loaded/saved
        // correctly albeit potentially 0s for star values.
        const levels = this.getHighestLevelNumber(playerStateData.levels.saga);
        for (let i = 0; i < levels - 1; i++) {
            levelData.push(0);
        }

        // Sort and override level_star star values with those from levelData.
        [...playerStateData.levels.saga]
            .sort((a, b) => a.levelNumber - b.levelNumber)
            .forEach(level => (levelData[level.levelNumber - 1] = level.stars));

        return {
            level_star: JSON.stringify(levelData),
        };
    }

    public restore(playerEndpointData: IPlayerData): ILevelDataMap {
        // Workaround for migration from SOLI1.0 to SOLI2.0:
        // Removes all values that are less than or equal to zero from the last greater than zero.
        const levelData = restoreStringifiedArray<number>(
            playerEndpointData.level_star
        );

        const lastIndex = levelData
            .map(value => typeof value === 'number' && value > 0)
            .lastIndexOf(true);
        if (lastIndex !== -1) {
            levelData.splice(lastIndex + 1);
        }

        return {
            saga: levelData.map((value, index) =>
                getNewLevelData({ levelNumber: index + 1, stars: value })
            ),
            challenge: [], // TODO: Restore challenge data.
        };
    }

    public isChanged(
        playerStateData: IPlayerState,
        playerEndpointData: IPlayerData
    ): boolean {
        return (
            this.save(playerStateData).level_star !==
            playerEndpointData.level_star
        );
    }

    /**
     * Player's current level number (the player's most recently unlocked level).
     */
    public getHighestLevelNumber(levels: ILevelData[]): number {
        return (
            levels.reduce((a, b) => {
                if (a === undefined || a < b.levelNumber) {
                    return b.levelNumber;
                } else {
                    return a;
                }
            }, 0) + 1
        );
    }
}
